import React, { useEffect, useRef } from 'react';
import { Box, List, ListItem, ListItemButton, ListItemAvatar, Avatar, Typography } from '@mui/material';
import { stringAvatar } from '../../../config/AvatarColor';

const MentionAutocomplete = ({
  inputValue,
  cursorPosition,
  onSelect,
  onClose,
  filteredMembers = [],
  selectedIndex = 0,
  denseList = true,
  nameTypographyVariant = "body2",
  nameTypographySx = {},
  containerSx = {},
}) => {
  const listRef = useRef(null);

  useEffect(() => {
    // Scroll selected item into view
    if (listRef.current && selectedIndex >= 0 && filteredMembers.length > 0) {
      const listElement = listRef.current.querySelector('ul');
      if (listElement && listElement.children[selectedIndex]) {
        listElement.children[selectedIndex].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }
  }, [selectedIndex, filteredMembers]);

  if (filteredMembers.length === 0) return null;

  const handleSelect = (member) => {
    onSelect(member);
    onClose();
  };

  return (
    <Box
      ref={listRef}
      sx={{
        position: 'absolute',
        bottom: '100%',
        mb: 1,
        bgcolor: 'background.paper',
        borderRadius: 2,
        boxShadow: 3,
        maxHeight: 300,
        overflow: 'auto',
        zIndex: 1000,
        minWidth: 250,
        border: (theme) => `1px solid ${theme.palette.divider}`,
        ...containerSx,
      }}
    >
      <List dense={denseList} sx={{ py: 0 }}>
        {filteredMembers.map((member, index) => (
          <ListItem
            key={member._id || member.id || index}
            disablePadding
          >
            <ListItemButton
              selected={index === selectedIndex}
              onMouseDown={(ev) => ev.preventDefault()}
              onClick={() => handleSelect(member)}
              sx={{
                bgcolor: index === selectedIndex ? 'action.selected' : 'transparent',
                '&:hover': {
                  bgcolor: 'action.hover',
                },
              }}
            >
              <ListItemAvatar>
                <Avatar {...stringAvatar(member.name)} />
              </ListItemAvatar>
              <Typography variant={nameTypographyVariant} sx={nameTypographySx}>
                {member.name}
              </Typography>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default MentionAutocomplete;
